import useCreateDistance from 'modules/cities/hooks/use-create-distance';
import useEditDistance from 'modules/cities/hooks/use-edit-distance';
import {DistanceProps, translatedDistanceProps} from 'modules/cities/types';
import {useLocation, useParams} from 'react-router-dom';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateDistance: React.FC = () => {
  const {id} = useParams();
  const {state = {} as any} = useLocation();
  const {getSelect, getNumberInput, getPriceInput} =
    useFormInputs<DistanceProps>();

  return (
    <Creation
      defaultValues={{cityId: id, ...state}}
      translationKey={translatedDistanceProps}
      onSubmit={() =>
        state?.id ? useEditDistance(id!, state.id) : useCreateDistance(id!)
      }
      inputs={[
        getSelect({
          name: 'operator',
          data: [
            {label: 'Até', value: 'lte'},
            {label: 'Maior que', value: 'gt'},
          ],
        }),
        getNumberInput({name: 'distance'}),
        getPriceInput({name: 'deliveryPrice'}),
        getPriceInput({name: 'deliveryManFee'}),
      ]}
      border
    />
  );
};

export default CreateDistance;
